import React, { useEffect, useState, useRef } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/styled-engine';
import { CssBaseline } from '@mui/material';

import store from "./store/index";

import theme, { darkTheme } from './theme';
import routes from './routes';

import Message from './components/partials/Message';
import ConfirmDialog from './components/partials/ConfirmDialog';
import { toggleMessageOpen } from "./store/actions/Message";

import apiClient from "./services/api";
import { getStorageValue } from './services/indexdb-service';

const App = () => {
    const isLoggedIn = useSelector((state) => state.auth.loggedIn);
    const routing = useRoutes(routes(isLoggedIn));
    const stateTheme = useSelector((state) => state.theme.currentTheme);
    const [currentTheme, setCurrentTheme] = useState(theme);

    const { t } = useTranslation();

    let interval = useRef(0);

    useEffect(() => {
        const loadModules = async () => {
            const modules = await getStorageValue('modules');

            store.dispatch({ type: "SET_MODULES", payload: modules });
        }
    
        loadModules()
    }, []);

    const startInterval = () => {
        interval.current = setInterval(() => {
            apiClient.post("api/heartbeat").catch((error) => {
                if (error?.response?.data?.message) {
                    store.dispatch(toggleMessageOpen(t(error.response.data.message), 'error'));
                }
            });
        }, process.env.REACT_APP_HEARTBEAT_INTERVAL_IN_SECONDS ? process.env.REACT_APP_HEARTBEAT_INTERVAL_IN_SECONDS * 1000 : 60000);
    }

    const stopInterval = () => {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = 0;
        }
    }

    useEffect(() => {
        if (isLoggedIn) {
            startInterval(isLoggedIn);
        } else {
            stopInterval();
        }

        return () => {
            stopInterval();
        };
    }, [isLoggedIn]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (stateTheme === 'Light') {
            setCurrentTheme(theme);
        } else {
            setCurrentTheme(darkTheme);
        }
    }, [stateTheme]);

    useEffect(() => {
    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                {routing}
                <ConfirmDialog />
                <Message />
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;